import { postTablesSnapshotAttributes } from '@ipfabric/api-client/client/model/snapshots/snapshots';
import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { useCallback, useEffect, useState } from 'react';

export const useDeviceAttributesCount = (
  snapshotId: string | null,
): {
  count: number | null;
  fetchCount: () => void;
} => {
  const [count, setCount] = useState<number | null>(null);

  const fetchCount = useCallback(async () => {
    if (snapshotId === null) {
      return;
    }
    try {
      const response = await postTablesSnapshotAttributes({
        snapshot: snapshotId,
        columns: ['id'],
        pagination: { limit: 0 },
      });

      setCount(response._meta.count);
    } catch {
      stumble('Failed to fetch attributes count');
    }
  }, [snapshotId]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  return { count, fetchCount };
};
